import React, { useMemo } from 'react';

import { Select } from 'vendors/semantic-ui';
import { getDefault, readCMSValue } from 'modules/shared-cms/utils';
import { SelectionFilterProps, FilterProps } from '../..';

export const SelectionFilter: React.FC<FilterProps<SelectionFilterProps>> = ({
    values,
    selectedValue,
    type,
    onSelectChange,
}: FilterProps<SelectionFilterProps>) => {
    const valueList = useMemo(() => {
        let result: {
            text: string;
            content?: React.ReactNode;
            value: string | number;
        }[] = [
            {
                text: 'Tous les modèles',
                content: <span>Tous les modèles</span>,
                value: -1,
            },
        ];

        if (!values || values.length === 0) {
            return result;
        }

        result = result.concat(
            values.map(v => {
                const value = getDefault(readCMSValue(v.id), '');
                const text = getDefault(readCMSValue(v.data.title), '');
                return {
                    value,
                    text,
                };
            }),
        );

        return result;
    }, [values]);

    const computedSelectedValue = useMemo(() => {
        if (!values || !selectedValue) {
            return -1;
        }

        if (Array.isArray(selectedValue)) {
            return selectedValue[0];
        }

        return selectedValue;
    }, [values, selectedValue]);

    return (
        <Select
            className="custom-selector"
            value={computedSelectedValue}
            options={valueList}
            onChange={(_e, data) => {
                const currentSelectedValue = selectedValue || -1;
                let hasChanged = false;
                if (Array.isArray(currentSelectedValue)) {
                    hasChanged = currentSelectedValue.indexOf(`${data.value}`) === -1;
                } else if (currentSelectedValue !== data.value) {
                    hasChanged = true;
                }

                if (hasChanged) {
                    if (data.value === -1) {
                        onSelectChange([], type);
                    } else {
                        onSelectChange(`${data.value}`, type);
                    }
                }
            }}
        />
    );
};
